import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const heart = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
